module.exports = __webpack_public_path__ + "img/paraglider_blue.dd673af4.png";